import {useEffect, useLayoutEffect} from 'react'

/**
 * useLayoutEffect that falls back to useEffect during SSR to avoid React warnings.
 * Use this when we need synchronous DOM measurements that only make sense in the browser.
 */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect

export default useIsomorphicLayoutEffect
